import { Phone, MessageCircle, Car } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { telLink, whatsappLink } from "@/lib/whatsapp";

export default function FloatingActions() {
  return (
    <div className="fixed z-40 right-4 md:right-6 bottom-4 md:bottom-6 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={whatsappLink("Hi Mamta Tours!")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="float-whatsapp"
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366]/60 animate-pulse-ring" />
        <WhatsAppIcon size={26} className="relative" />
      </a>
      <a
        href={telLink()}
        aria-label="Call"
        data-testid="float-call"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-brand-blue text-white shadow-[0_10px_30px_-6px_rgba(11,77,184,0.6)] hover:bg-brand-orange transition-colors"
      >
        <Phone className="w-5 h-5" />
      </a>
      <a
        href="#home"
        aria-label="Book online"
        data-testid="float-book"
        className="hidden md:flex items-center justify-center w-14 h-14 rounded-full bg-brand-orange text-white shadow-[0_10px_30px_-6px_rgba(255,140,0,0.6)] hover:bg-brand-blue transition-colors"
      >
        <Car className="w-5 h-5" />
      </a>
    </div>
  );
}
